import { useState, useRef, useEffect } from "react";

const API = "https://surabaya-api.onrender.com/api";

const SUGGESTIONS = [
  "Y'a des alertes en cours ?",
  "Combien de couverts ce soir ?",
  "État des frigos ?",
  "Résas de la semaine ?",
  "Tâches en cours pour l'équipe ?",
];

const EQUIPE = [
  { nom: "Patrick", emoji: "🔧", couleur: "#f97316", desc: "Maintenance" },
  { nom: "Christian", emoji: "👨‍🍳", couleur: "#4ade80", desc: "Cuisine" },
  { nom: "Coralie", emoji: "🍽️", couleur: "#60a5fa", desc: "Service" },
  { nom: "Mamat", emoji: "☕", couleur: "#e8c47c", desc: "Patron" },
];

const JarvisAvatar = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="38" fill="#1a0f07"/>
    <ellipse cx="40" cy="44" rx="26" ry="24" fill="#c4956a"/>
    <ellipse cx="17" cy="28" rx="10" ry="14" fill="#b07d50" transform="rotate(-8 17 28)"/>
    <ellipse cx="17" cy="29" rx="6" ry="9" fill="#c4856a" transform="rotate(-8 17 29)"/>
    <ellipse cx="63" cy="28" rx="10" ry="14" fill="#b07d50" transform="rotate(8 63 28)"/>
    <ellipse cx="63" cy="29" rx="6" ry="9" fill="#c4856a" transform="rotate(8 63 29)"/>
    <path d="M28 34 Q34 30 38 32" stroke="#6b3e1a" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
    <path d="M42 32 Q46 30 52 34" stroke="#6b3e1a" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
    <ellipse cx="32" cy="41" rx="7" ry="6" fill="white"/>
    <ellipse cx="48" cy="41" rx="7" ry="6" fill="white"/>
    <circle cx="33" cy="41" r="4" fill="#1a0a04"/>
    <circle cx="49" cy="41" r="4" fill="#1a0a04"/>
    <circle cx="34" cy="39" r="1.5" fill="white"/>
    <circle cx="50" cy="39" r="1.5" fill="white"/>
    <circle cx="48" cy="41" r="8" fill="none" stroke="#e8c47c" strokeWidth="1.5"/>
    <line x1="56" y1="41" x2="61" y2="43" stroke="#e8c47c" strokeWidth="1.5"/>
    <ellipse cx="40" cy="52" rx="14" ry="10" fill="#b07d50"/>
    <ellipse cx="40" cy="53" rx="10" ry="7" fill="#c4856a"/>
    <ellipse cx="40" cy="48" rx="7" ry="5" fill="#2a1a0a"/>
    <ellipse cx="22" cy="54" rx="6" ry="5" fill="#c47560" opacity="0.45"/>
    <ellipse cx="58" cy="54" rx="6" ry="5" fill="#c47560" opacity="0.45"/>
    <rect x="24" y="10" width="32" height="18" rx="2" fill="#1a0f07"/>
    <rect x="20" y="26" width="40" height="5" rx="1" fill="#1a0f07"/>
    <rect x="25" y="25" width="30" height="3" rx="1" fill="#e8c47c"/>
    <polygon points="35,66 40,69 35,72" fill="#c8341a"/>
    <polygon points="45,66 40,69 45,72" fill="#c8341a"/>
    <circle cx="40" cy="69" r="2" fill="#e04020"/>
  </svg>
);

const SURA_BROWN = "#1a0f07";
const SURA_GOLD = "#e8c47c";

export default function StaffAssistant() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [personneCible, setPersonneCible] = useState(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    fetch(`${API}/dashboard`).then(r => r.json()).then(d => {
      const a = [];
      if (d.haccp?.frigos_sans_saisie?.length > 0) a.push(`${d.haccp.frigos_sans_saisie.length} frigo(s) sans relevé`);
      if (d.haccp?.releves_non_conformes?.length > 0) a.push(`${d.haccp.releves_non_conformes.length} relevé(s) non conforme(s)`);
      if (d.stock?.alertes?.length > 0) a.push(`${d.stock.alertes.length} stock(s) sous le seuil`);
      setAlerts(a);
    }).catch(() => {});
  }, []);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, loading]);

  const send = async (text) => {
    const userMsg = text || input.trim();
    if (!userMsg || loading) return;
    setInput("");
    setPersonneCible(null);
    const newMessages = [...messages, { role: "user", content: userMsg }];
    setMessages(newMessages);
    setLoading(true);
    try {
      const res = await fetch(`${API}/staff/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: newMessages })
      });
      const data = await res.json();
      const textBlocks = data.content?.filter(b => b.type === "text") || []; const reply = textBlocks.length > 0 ? textBlocks.map(b => b.text).join("\n") : (data.error?.message || "Erreur de réponse.");
      setMessages([...newMessages, { role: "assistant", content: reply }]);
    } catch { setMessages([...newMessages, { role: "assistant", content: "Erreur de connexion." }]); }
    setLoading(false);
  };

  const selectionnerPersonne = (personne) => {
    setPersonneCible(personne);
    setInput(`Nouvelle tâche pour ${personne.nom} : `);
  };

  const handleKey = (e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", maxWidth: 680, margin: "0 auto", fontFamily: "var(--font-sans)" }}>

      {/* Header */}
      <div style={{ background: SURA_BROWN, padding: "12px 16px", display: "flex", alignItems: "center", gap: 12 }}>
        <JarvisAvatar size={44} />
        <div>
          <div style={{ color: SURA_GOLD, fontSize: 16, fontWeight: 500 }}>Jarvis</div>
          <div style={{ color: "#8a6a40", fontSize: 12 }}>Assistant Surabaya · données en direct</div>
        </div>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 6 }}>
          <div style={{ width: 7, height: 7, borderRadius: "50%", background: "#4ade80" }}/>
          <span style={{ color: "#8a6a40", fontSize: 11 }}>En ligne</span>
        </div>
      </div>

      {/* Chips équipe */}
      <div style={{ background: "#2a1a0a", padding: "10px 16px", display: "flex", gap: 8, flexWrap: "wrap", borderBottom: "0.5px solid #3d2a10" }}>
        <span style={{ fontSize: 11, color: "#8a6a40", alignSelf: "center", marginRight: 4 }}>Assigner à :</span>
        {EQUIPE.map(p => (
          <button key={p.nom} onClick={() => selectionnerPersonne(p)} style={{
            fontSize: 12, padding: "5px 12px", borderRadius: 20, cursor: "pointer",
            background: personneCible?.nom === p.nom ? p.couleur + "30" : "transparent",
            border: `0.5px solid ${personneCible?.nom === p.nom ? p.couleur : "#5a3a1a"}`,
            color: personneCible?.nom === p.nom ? p.couleur : "#a07040",
            transition: "all 0.15s", fontFamily: "var(--font-sans)"
          }}>
            {p.emoji} {p.nom}
          </button>
        ))}
      </div>

      {/* Alertes */}
      {alerts.length > 0 && (
        <div style={{ background: "#3d1a08", borderBottom: "1px solid #5a2a10", padding: "8px 16px", display: "flex", gap: 16, flexWrap: "wrap" }}>
          {alerts.map((a, i) => (
            <span key={i} style={{ fontSize: 12, color: "#f5e6b8", display: "flex", alignItems: "center", gap: 5 }}>
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#f97316", display: "inline-block" }}/>{a}
            </span>
          ))}
        </div>
      )}

      {/* Messages */}
      <div style={{ flex: 1, overflowY: "auto", padding: "16px", display: "flex", flexDirection: "column", gap: 14, background: "var(--color-background-tertiary)" }}>
        {messages.length === 0 && (
          <div style={{ padding: "1rem 0" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
              <JarvisAvatar size={32} />
              <div style={{ background: "var(--color-background-primary)", border: "0.5px solid var(--color-border-tertiary)", borderRadius: "16px 16px 16px 4px", padding: "10px 14px", fontSize: 14, color: "var(--color-text-primary)", lineHeight: 1.55 }}>
                Bonjour ! Je surveille le Surabaya en temps réel. Utilisez les chips en haut pour assigner une tâche à l'équipe, ou posez-moi une question.
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, paddingLeft: 42 }}>
              {SUGGESTIONS.map((s, i) => (
                <button key={i} onClick={() => send(s)} style={{ fontSize: 12, padding: "6px 12px", borderRadius: 20, background: "var(--color-background-primary)", border: `0.5px solid ${SURA_GOLD}`, color: SURA_BROWN, cursor: "pointer", fontFamily: "var(--font-sans)" }}>{s}</button>
              ))}
            </div>
          </div>
        )}

        {messages.map((m, i) => (
          <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: m.role === "user" ? "flex-end" : "flex-start", gap: 4 }}>
            {m.role === "assistant" && (
              <div style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
                <JarvisAvatar size={28} />
                <div style={{ maxWidth: "80%", padding: "10px 14px", borderRadius: "16px 16px 16px 4px", background: "var(--color-background-primary)", border: "0.5px solid var(--color-border-tertiary)", color: "var(--color-text-primary)", fontSize: 14, lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{m.content}</div>
              </div>
            )}
            {m.role === "user" && (
              <div style={{ maxWidth: "80%", padding: "10px 14px", borderRadius: "16px 16px 4px 16px", background: SURA_BROWN, color: SURA_GOLD, fontSize: 14, lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{m.content}</div>
            )}
          </div>
        ))}

        {loading && (
          <div style={{ display: "flex", alignItems: "flex-end", gap: 8 }}>
            <JarvisAvatar size={28} />
            <div style={{ padding: "10px 14px", borderRadius: "16px 16px 16px 4px", background: "var(--color-background-primary)", border: "0.5px solid var(--color-border-tertiary)", display: "flex", gap: 5, alignItems: "center" }}>
              {[0,1,2].map(i => <div key={i} style={{ width: 7, height: 7, borderRadius: "50%", background: SURA_GOLD, opacity: 0.4, animation: `pulse 1.2s ${i*0.2}s infinite` }}/>)}
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      <div style={{ padding: "12px 16px", borderTop: "0.5px solid var(--color-border-tertiary)", background: "var(--color-background-primary)" }}>
        {personneCible && (
          <div style={{ marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ fontSize: 12, color: "#8a6a40" }}>Tâche pour</span>
            <span style={{ fontSize: 12, fontWeight: 500, color: personneCible.couleur, padding: "2px 10px", borderRadius: 20, border: `0.5px solid ${personneCible.couleur}`, background: personneCible.couleur + "20" }}>{personneCible.emoji} {personneCible.nom}</span>
            <button onClick={() => { setPersonneCible(null); setInput(""); }} style={{ fontSize: 11, color: "var(--color-text-secondary)", background: "none", border: "none", cursor: "pointer" }}>✕</button>
          </div>
        )}
        {messages.length > 0 && !personneCible && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 }}>
            {SUGGESTIONS.slice(0,3).map((s, i) => (
              <button key={i} onClick={() => send(s)} style={{ fontSize: 11, padding: "4px 10px", borderRadius: 20, background: "transparent", border: `0.5px solid ${SURA_GOLD}`, color: "var(--color-text-secondary)", cursor: "pointer", fontFamily: "var(--font-sans)" }}>{s}</button>
            ))}
          </div>
        )}
        <div style={{ display: "flex", gap: 8, alignItems: "flex-end" }}>
          <textarea value={input} onChange={e => setInput(e.target.value)} onKeyDown={handleKey}
            placeholder={personneCible ? `Décrivez la tâche pour ${personneCible.nom}...` : "Posez votre question..."}
            rows={1} style={{ flex: 1, resize: "none", fontSize: 14, padding: "10px 14px", borderRadius: 20, border: `0.5px solid ${personneCible ? personneCible.couleur : "var(--color-border-secondary)"}`, background: "var(--color-background-secondary)", color: "var(--color-text-primary)", fontFamily: "var(--font-sans)", outline: "none" }} />
          <button onClick={() => send()} disabled={loading || !input.trim()} style={{ width: 40, height: 40, borderRadius: "50%", background: loading || !input.trim() ? "var(--color-background-secondary)" : SURA_BROWN, border: "none", cursor: loading || !input.trim() ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill={loading || !input.trim() ? "var(--color-text-tertiary)" : SURA_GOLD}><path d="M2 21L23 12 2 3v7l15 2-15 2v7z"/></svg>
          </button>
        </div>
        <p style={{ fontSize: 11, color: "var(--color-text-tertiary)", margin: "6px 0 0", textAlign: "center" }}>Entrée pour envoyer · Shift+Entrée pour nouvelle ligne</p>
      </div>
      <style>{`@keyframes pulse{0%,80%,100%{opacity:0.3}40%{opacity:1}}`}</style>
    </div>
  );
}
